import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_search_loader = _resolveComponent("post-search-loader")!
  const _component_post_search = _resolveComponent("post-search")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Search Results",
    size: "lg",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_post_search_loader, {
        "post-search-id": _ctx.postSearchId,
        modelValue: _ctx.postSearch,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postSearch) = $event))
      }, null, 8, ["post-search-id", "modelValue"]),
      (_ctx.postSearch)
        ? (_openBlock(), _createBlock(_component_post_search, {
            key: 0,
            "post-search": _ctx.postSearch
          }, null, 8, ["post-search"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}